import React from 'react';

const BradCrumbs = props => {
  return (
    <>
      <div className="brad-crumbs py-24">
        {props.items.map((item, ind) => {
          return (
            <>
              <a href={item.url} className={'text-purple text-16'}>
                {item.name}
              </a>
              {ind != props.items.length - 1 && <span className={'px-10'}>{'>'}</span>}
            </>
          );
        })}
      </div>
    </>
  );
};
export default BradCrumbs;
